// extracted by mini-css-extract-plugin
export default {"autosize":"style_autosize__3c+dN"};